import React from "react";
import  "./BotonColor.css"
import { Button} from "semantic-ui-react";

 function BotonColor(props) {
  const { btnTitulo, funcion } = props;
  return (
    <div>
      <Button className="buttonIni" onClick={funcion}>
        {btnTitulo}
      </Button>
    </div>
  );
}
export default BotonColor;